import { InfoCircleOutlined } from "@ant-design/icons";
import { Space } from "antd";

import TooltipWrapper from "../common-utils/TooltipWrapper";

const INFO_ICON_STYLE = { color: "var(--text-secondary)", cursor: "pointer" };

/**
 * The info icon carrying a tab, column, filter or metric's one-sentence
 * explanation, written for an admin who has never read this code.
 *
 * @param {object} props
 * @param {string} props.title Sentence shown on hover.
 * @returns {JSX.Element}
 */
const InfoHint = ({ title }) => (
  <TooltipWrapper
    title={title}
    body={<InfoCircleOutlined style={INFO_ICON_STYLE} />}
  />
);

/**
 * A label followed by its info icon, for a column title, card title or filter
 * that carries an explanation.
 *
 * @param {object} props
 * @param {import("react").ReactNode} props.label - The text or node shown before the icon.
 * @param {string} props.infoText - Sentence shown when the icon is hovered.
 * @returns {JSX.Element}
 */
export const LabelWithHint = ({ label, infoText }) => (
  <Space size={4}>
    {label}
    <InfoHint title={infoText} />
  </Space>
);

export default InfoHint;
